module.exports = __webpack_public_path__ + "media/images/Cup-and-Candle-1920px-4-734f10abba6b1b2ae73a1d9c74f97b99.png";